/**
 * Created by filatov on 18.09.2015.
 */
import CostCSVPreviewTwoLevelsColumnsStrategy from './CostCSVPreviewTwoLevelsColumnsStrategy'

export default function CostCSVPreviewTwoLevelsGroupsOnlyColumnsStrategy() {}

CostCSVPreviewTwoLevelsGroupsOnlyColumnsStrategy.prototype = new CostCSVPreviewTwoLevelsColumnsStrategy();

CostCSVPreviewTwoLevelsGroupsOnlyColumnsStrategy.prototype.init = function({showSpentTime, showAverageRates, showOthers}) {
    CostCSVPreviewTwoLevelsColumnsStrategy.prototype.init.call(
        this,
        {
            showSpentTime: showSpentTime,
            showAverageRates: showAverageRates,
            showOthers: showOthers,
        }
    )
    return this
}

CostCSVPreviewTwoLevelsGroupsOnlyColumnsStrategy.prototype.getLevelNameKey = function(){
    return "user.group";
};

CostCSVPreviewTwoLevelsGroupsOnlyColumnsStrategy.prototype.isShowRatesForTopLevel = function () {
    return this.showAverageRates;
};



// WEBPACK FOOTER //
// ./web/js/reports/preview/csv/cost/CostCSVPreviewTwoLevelsGroupsOnlyColumnsStrategy.js